<template>
  <dashboard />
</template>

<script>
import Dashboard from './components/Dashboard.vue'
export default {
  name: "App",
  components: {
    Dashboard
  }
};
</script>
<style>
  @import './assets/styles/global.css';
</style>